import { IHttpApi } from '@cian/http-api/shared';

import { assertUnknownError } from './assert';
import { mapAddOfferToComparisonResponse, mapAddOfferToComparisonResponseError } from './mappers';
import {
  fetchAddOfferToComparison,
  IAddOfferToComparisonRequest,
  IAddOfferToComparisonResponse,
} from '../../../repositories/offers-comparison/v2/add-offer-to-comparison';

export async function addOfferToComparisonRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: IAddOfferToComparisonRequest;
}): Promise<IAddOfferToComparisonResponse> {
  const response = await fetchAddOfferToComparison({
    httpApi,
    parameters,
    config: {},
    mappers: {
      200: mapAddOfferToComparisonResponse,
      400: mapAddOfferToComparisonResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as IAddOfferToComparisonResponse;
}
